import * as SimpleLoaderStyles from './components/SimpleLoader.css';
export default {
    SimpleLoaderStyles
};
